import React from 'react';
import _ from 'lodash';
import {format} from 'date-fns';
import '../../less/bootstrap.less';
import '../../assets/css/myob.css';
import '../../assets/css/intray.css';
import '../../assets/css/receipt.css';
import './ViewInvoice.css'
import {Campaign, IAnalyticsService} from '../../services/IAnalyticsService';
import {WrapperModalDialog} from '../components/ModalDialog'
import {IInvoiceService} from '../../services/IInvoiceService';
import {HeaderInvoice, HeaderFooterInvoice} from '../components/HeaderInvoice'
import FooterInvoice from '../components/FooterInvoice';
import {shouldShowPaymentNotification, shouldShowPayButton} from '../../utils/invoice';
import {isAndroid} from 'react-device-detect'
import {Document, Page, pdfjs} from 'react-pdf'
import {ReceiptBody} from '../components/ReceiptBody';
import {getDisplayReceipts} from '../../utils/invoice';
import queryString from 'query-string';
import {buildCampaign} from '../../utils/CampaignBuilder';
import {EventName, PageName} from '../../enum/AnalyticsEnum';
import {signInAndLinkModel, sendInTray, unLinkModel} from '../components/IntrayModel'
import {ecalAlert} from "../components/EcalAlert";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

declare global {
    interface Window {
        triggerCompanyList: () => void;
    }
}

export type ViewInvoiceProps = {
    readonly notifyEvent: IAnalyticsService['notifyEvent']
    readonly getInvoice: IInvoiceService['getInvoice']
    readonly getInvoicePdf: IInvoiceService['getInvoicePdf']
    readonly retrieveSuppliersFeed: IInvoiceService['retrieveSuppliersFeed']
    readonly createSupplierFeed: IInvoiceService['createSupplierFeed']
    readonly removeSupplierFeed: IInvoiceService['removeSupplierFeed']
    readonly login: IInvoiceService['login']
    readonly submitToInTray: IInvoiceService['submitToInTray']
    readonly getCompanyList: IInvoiceService['getCompanyList']
    readonly closeSelectCompany: IInvoiceService['closeSelectCompany']
    readonly params?: any
    readonly useLocation?: any
    readonly navigateToPage?: (link: string) => void
}

export type ViewInvoiceState = {
    readonly invoice: any
    readonly invoicePdfContent: any
    readonly loading: boolean
    readonly error: boolean
    readonly takingPayment: boolean
    readonly recording: boolean
    readonly loadingPdf: boolean
    readonly numPages: number
    readonly showReceipt: boolean
    readonly companyList: Array<String>
    readonly showInTrayButtons: boolean
    readonly supplierFeedExists: boolean
    readonly loadingIntray: boolean
    readonly inTrayLinked: boolean
    readonly clickedSignIn: boolean
    readonly sendIntrayErrorMessage: string
    readonly showSendInTrayLoginModal: boolean
    readonly showSignIn: boolean
    readonly showUnlink: boolean
    readonly showSendIntray: boolean,
    readonly companyId: string
}


export class ViewInvoice extends React.Component<ViewInvoiceProps, ViewInvoiceState> {

    readonly history: string[] = []
    private pdfWrapper: HTMLDivElement | null;

    constructor(props) {
        super(props)
        this.state = {
            invoice: null,
            invoicePdfContent: null,
            loading: true,
            error: false,
            takingPayment: false,
            recording: false,
            loadingPdf: false,
            numPages: 0,
            showReceipt: false,
            showInTrayButtons: false,
            supplierFeedExists: false,
            loadingIntray: false,
            inTrayLinked: false,
            clickedSignIn: false,
            companyList: [],
            sendIntrayErrorMessage: '',
            showSendInTrayLoginModal: false,
            showSignIn: false,
            showUnlink: false,
            showSendIntray: false,
            companyId: ''
        }
        this.pdfWrapper = null;
        this.onDocumentLoadSuccess.bind(this);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.params!=this.props.params) {
            this.setState({
                ...this.state,
                loading: true
            })
            const {invoiceId} = this.props.params;
            this.onGetInvoice(invoiceId);
        }
    }

    public componentDidMount() {
        const {invoiceId} = this.props.params;
        this.onGetInvoice(invoiceId);
    }

    render() {
        const {
            invoice,
            loading,
            error,
            takingPayment,
            recording,
            showInTrayButtons,
            supplierFeedExists,
            showSignIn,
            sendIntrayErrorMessage,
            clickedSignIn,
            showUnlink,
            loadingIntray,
            inTrayLinked,
            showSendIntray,
            companyList,
            companyId,
            showSendInTrayLoginModal
        } = this.state;

        return (
            <div>
                <HeaderInvoice loading={loading} error={error} takingPayment={takingPayment} recording={recording}
                               invoice={invoice} inPayment={takingPayment} showInTrayButtons={showInTrayButtons}
                               supplierFeedExists={supplierFeedExists} print={this.print} linkToMYOB={this.linkToMYOB}
                               isShowEcalAlert={this.isShowEcalAlert()}
                               removeLinkFromMYOB={this.removeLinkFromMYOB} activity={this.activity}/>
                {this.renderRecording(recording)}
                {this.renderContent()}
                {(!loading && invoice && !shouldShowPayButton(invoice)) && this.renderReceipt()}
                {!loading && invoice &&
                    <div>
                        {signInAndLinkModel(showSignIn, !_.isEmpty(sendIntrayErrorMessage), clickedSignIn, invoice, this.closeSelectCompany, this.sendToInTray)}
                        {sendInTray(showSendIntray, !_.isEmpty(sendIntrayErrorMessage), loadingIntray, inTrayLinked, showSendInTrayLoginModal, companyId,
                            invoice, companyList, this.closeSelectCompany, this.removeLinkFromMYOB, this.confirmCompany, this.handleSelectCompany)}
                        {unLinkModel(showUnlink, !_.isEmpty(sendIntrayErrorMessage), loadingIntray, inTrayLinked, invoice,
                            this.closeUnlinkFromMYOB, this.unlinkFromInTray)}
                    </div>}
                <FooterInvoice country={'AU'}/>
                <HeaderFooterInvoice loading={loading} error={error} takingPayment={takingPayment} recording={recording}
                               invoice={invoice} inPayment={takingPayment}/>
            </div>
        )
    }

    isShowEcalAlert = () => {
        const searchParams = queryString.parse(this.props.useLocation.search)
        const isShowEcal = _.get(searchParams, 'redirect', false)
        return _.isEqual(isShowEcal, 'true');
    }

    renderContent() {
        if (this.state.loading || this.state.error || !this.state.invoice) {
            return null;
        }
        return (<div>
            {this.renderButtonWrapper()}
            {this.renderPdf(this.state.invoicePdfContent)}
        </div>)

    }

    renderPdf(invoicePdfContent) {
        if (invoicePdfContent) {
            const binaryImg = atob(invoicePdfContent);
            const length = binaryImg.length;
            const arrayBuffer = new ArrayBuffer(length);
            const uintArray = new Uint8Array(arrayBuffer);
            for (let i = 0; i < length; i++) {
                uintArray[i] = binaryImg.charCodeAt(i);
            }
            let pdfWidth = 960
            if (window.innerWidth < 992) {
                pdfWidth = window.innerWidth;
            }
            return <div className='hidden-xs invoice-display ng-scope'>
                <div className='container' id='pdfWrapper'>
                    <Document file={{ data: uintArray }}
                              onLoadSuccess={this.onDocumentLoadSuccess}
                              onLoadError={error => {
                                  this.setState({
                                      ...this.state,
                                      error: true
                                  })
                                  console.log("err" + error);
                              }}
                    >
                        {this.loadMultiPage(pdfWidth)}
                    </Document>
                </div>
            </div>
        }
    }


    loadMultiPage = (pdfWidth) => {
        return new Array(this.state.numPages).fill("").map((item, index) => {
            return <Page className={"pdf-page"}
                         width={pdfWidth}
                         renderTextLayer={false}
                         renderAnnotationLayer={false}
                         key={`page_${index + 1}`}
                         pageNumber={index + 1}/>;
        })
    }

    onDocumentLoadSuccess = (pdfDocument) => {
        const numPages = pdfDocument._pdfInfo.numPages;
        console.log('page', pdfDocument._pdfInfo.numPages);
        if (this.state.numPages > 0) {
            return;
        }
        this.setState({
            ...this.state,
            numPages
        })
    }

    renderRecording(recording) {
        return recording && (
            <div className='loading_invoice text-center'>
                <div className='flx-loading-spinner-lg'></div>
            </div>)
    }

    renderButtonWrapper() {
        const ieVersion9 = !!document['documentMode'] && document['documentMode'] === 9;
        if (this.state.loading || this.state.error || !this.state.invoice) {
            return null;
        }
        return <>
            {ieVersion9 && <div id='ie_invoice_controls'>{this.renderButtonAction()}</div>}
            {!ieVersion9 &&
                <div id='invoice_controls' data-offset-top='139' data-spy='affix'>{this.renderButtonAction()}</div>}
        </>
    }

    renderMobileButton() {
        const invoice = this.state.invoice
        const {supplierFeedExists, showInTrayButtons} = this.state
        return (
            <div className='mobile-admin-buttons'>
                {invoice.pdf_available == true && !invoice.meta.status_is_overridden && (
                    <div className='btn-group-vertical' style={{width: '100%'}}>
                        <div className='invoice_toolbar btn-group visible-xs'>
                            {isAndroid && <a id='download-mobile-invoice-control' className='btn btn-default btn-lg'
                                             href={invoice.download_pdf_url} download><i
                                className='icon-archive'></i><span
                                className='button-label'>&nbsp;&nbsp;Download PDF</span></a>}
                            {!isAndroid && <a id='download-mobile-invoice-control' className='btn btn-default btn-lg'
                                              href={invoice.download_pdf_url} download><i
                                className='icon-archive'></i><span
                                className='button-label'>&nbsp;&nbsp;Download PDF</span></a>}
                        </div>
                        <div className='invoice_toolbar btn-group visible-xs'>
                            {!supplierFeedExists && showInTrayButtons && <a id='send-to-intray-control'
                                                                            className='btn btn-default btn-lg'
                                                                            onClick={this.linkToMYOB}><i
                                className='icon-linked2'></i><span
                                className='button-label'>&nbsp;&nbsp;Link to MYOB</span></a>}
                            {supplierFeedExists && showInTrayButtons && <a id='unlink-from-intray-control'
                                                                           className='btn btn-default btn-lg'
                                                                           onClick={this.removeLinkFromMYOB}><i
                                className='icon-unlink'></i><span
                                className='button-label'>&nbsp;&nbsp;Unlink from MYOB</span></a>}
                        </div>
                        <div className='invoice_toolbar btn-group visible-xs'>
                            <a id='invoice-mobile-activity-control'
                               className='btn btn-default btn-lg' onClick={this.activity}><i
                                className='icon-history'></i><span
                                className='button-label'>&nbsp;&nbsp;Invoice activity</span></a>
                        </div>
                    </div>
                )}
            </div>)
    }

    renderButtonAction() {
        const invoice = this.state.invoice
        return (
            <div className='container'>
                <div className='row myob'>
                    {shouldShowPaymentNotification(invoice) && <div className='alert alert-info PaymentNotification'>
                        <span>Payment advised on {
                            format(new Date(invoice.latest_payment_notification.occurred_at), 'dd/MM/yyyy')} using </span>
                        {invoice.latest_payment_notification.notification.type == 'bpay' && <span> BPAY. </span>}
                    </div>
                    }
                </div>

                <div className='invoice_action_wrapper'>
                    {shouldShowPayButton(invoice) && <div className='invoice_pay'>
                        <div>
                            <button className='btn btn-primary btn-lg' type='button' id='pay_now'
                                    onClick={this.payNow}>Pay now
                            </button>
                        </div>
                    </div>
                    }
                    {!_.isEmpty(invoice.receipts) && <div className='invoice_pay'>
                        <div>
                            <button className='btn btn-primary btn-lg' type='button' id='receipts'
                                    onClick={this.viewReceipt}>
                                View receipt
                            </button>
                        </div>
                    </div>}
                    <div className='hidden-xs' id='ecalContainer'>{ecalAlert(this.isShowEcalAlert())}</div>
                    {this.renderMobileButton()}
                </div>
            </div>
        )
    }


    renderReceipt() {
        console.log('should load popup');
        const showReceipt = this.state.showReceipt;
        const displayReceipts = getDisplayReceipts(this.state.invoice);
        return (
            <WrapperModalDialog show={showReceipt} close={this.closeReceipt} title={'Invoice Receipt'}
                                titleCenter={false} id={'receipt'}>
                <ReceiptBody displayReceipts={displayReceipts}/>
            </WrapperModalDialog>
        )
    }

    onGetInvoice = (hash: string) => {
        this.props.getInvoice(hash)
            .then(res => this.onGetInvoicePdf(res.data))
            .then(res => this.loadSupplierFeed(res.invoice, res.invoicePdfContent))
            .then(res => {
                this.setState({
                    ...this.state,
                    ...res,
                    loading: false
                }, () => {
                    this.loadSegmentEvent();
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false,
                    error: true
                });
                console.log('get invoice error' + err);
            });
    }

    getSupplierFeed = (invoice: any) => {
        const supplierId = invoice.company.uid;
        const clientId = invoice.customer.id;
        const state = invoice.state;
        const country = invoice.company.country.trim();
        const product = invoice.consumer.trim();
        return this.props.retrieveSuppliersFeed(supplierId, clientId, country, product, state).then(res => {
            return res;
        });
    }

    loadSupplierFeed = (invoice: any, invoicePdfContent: any) => {
        if (_.isBoolean(invoice.featureFlag.myobToMyobFeatureName)) {
            return Promise.resolve({invoice, invoicePdfContent});
        }
        return this.getSupplierFeed(invoice).then(res => {
            const showInTrayButtons = true;
            let supplierFeedExists = false;
            let inTrayLinked = false;
            if (!_.isEmpty(res)) {
                supplierFeedExists = true;
                inTrayLinked = true;
            }
            return {
                invoice,
                invoicePdfContent,
                showInTrayButtons,
                supplierFeedExists,
                inTrayLinked
            }
        })
    }

    onGetInvoicePdf = (invoice: any) => {
        return this.props.getInvoicePdf(invoice.view_pdf_url).then(res => {
            return {
                invoice,
                invoicePdfContent: res.data.contents,
            }
        })
    }

    loadSegmentEvent() {
        const {useLocation, notifyEvent} = this.props;
        const {invoice} = this.state;
        const query = queryString.parse(useLocation.search);
        const source = _.get(query, 'source', '');
        const type = _.get(query, 'type', '');
        const invoiceId = _.get(query, 'invoiceId', '');
        const campaign: Campaign = buildCampaign(PageName.VIEW, type);
        const activityData = {
            invoice,
            source,
            campaign,
            invoiceId
        };
        notifyEvent(EventName.VIEW_INVOICE, activityData);
    }

    activity = () => {
        const {invoiceId} = this.props.params;
        this.props.navigateToPage && this.props.navigateToPage(`/${invoiceId}/activity${this.props.useLocation.search}`)
        console.log('activity');

    }

    payNow = () => {
        const {invoiceId} = this.props.params;
        const {useLocation, notifyEvent} = this.props;
        const {invoice} = this.state;
        this.history.push('pay-now-button');
        const query = queryString.parse(useLocation.search);
        const source = _.get(query, 'source', '');
        const type = _.get(query, 'type', '');
        const campaign: Campaign = buildCampaign(PageName.PAY_VIEW, type);
        const activityData = {
            invoice: invoice,
            source,
            campaign,
            history: this.history,
            invoiceId: _.get(query, 'invoiceId', '')
        };
        notifyEvent(EventName.PAY_NOW_BUTTON, activityData);
        this.props.navigateToPage && this.props.navigateToPage(`/${invoiceId}/pay${this.props.useLocation.search}`)
    }

    viewReceipt = () => {
        this.setState({
            ...this.state,
            showReceipt: true
        });
    }

    closeReceipt = () => {
        console.log('click close');
        this.setState({
            ...this.state,
            showReceipt: false
        });
    }

    linkToMYOB = () => {
        this.setState({
            ...this.state,
            companyList: [],
            clickedSignIn: false,
            inTrayLinked: false,
            sendIntrayErrorMessage: '',
            showSignIn: true,
        });
    }

    triggerGetCompanyList = () => {
        console.log('trigger CompanyList list');
        this.setState({
            ...this.state,
            clickedSignIn: false,
            loadingIntray: true,
            showSignIn: false,
            showSendIntray: true,
            sendIntrayErrorMessage: ''
        });
        this.props.getCompanyList().then(companylist => {
            let value = ''
            if (companylist.length >= 1) {
                const company = companylist[0];
                value = `${company.uid},${company.productName},${company.serialNumber}`
            }
            this.setState({
                ...this.state,
                companyList: companylist,
                loadingIntray: false,
                showSendInTrayLoginModal: false,
                showSendIntray: true,
                companyId: value
            });
        }).catch(() => {
                this.setState({
                    ...this.state,
                    sendIntrayErrorMessage: 'Incorrect username and password.'
                });
            }
        )
    }

    sendToInTray = () => {
        const {notifyEvent} = this.props;
        const {invoice} = this.state;
        this.setState({
            ...this.state,
            loadingIntray: false,
            showSendInTrayLoginModal: true,
            clickedSignIn: true,
            sendIntrayErrorMessage: ''
        })
        const {invoiceId} = this.props.params;
        this.getSupplierFeed(this.state.invoice)
            .then(() => {
               return true;
            }).then(supplierFeedExists => {
            if (supplierFeedExists) {
                notifyEvent(EventName.LOGIN_INTRAY, {
                    invoice
                });
                return this.props.login(invoiceId)
            }
        }).then(response => {
            const newWindow = window.open(response.url, '_blank');
            window.triggerCompanyList = () => {
                if (newWindow) {
                    newWindow.close()
                }
                this.triggerGetCompanyList();
            };
        }).catch(() => {
            this.setState({
                ...this.state,
                loadingIntray: false,
                showSendInTrayLoginModal: false,
                sendIntrayErrorMessage: 'Send to intray error',
                showSendIntray: false
            })
        })
    }

    handleSelectCompany = (value: string) => {
        if (_.isEmpty(value)) {
            return
        }
        this.setState({
            ...this.state,
            companyId: value
        })
    }

    confirmCompany = () => {
        this.setState({
            ...this.state,
            loadingIntray: true
        })
        const { notifyEvent } = this.props;
        const { invoiceId } = this.props.params;
        const invoice = this.state.invoice;
        const supplierId = invoice.company.uid;
        const clientId = invoice.customer.id;
        const clientInfo = this.state.companyId.split(',');
        const businessId = clientInfo[0];
        const serialNumber = clientInfo[2];
        const productName = clientInfo[1].split('_');
        const product = productName[0];
        const country = productName[1];

        this.props.createSupplierFeed(this.state.invoice, businessId, country, product, serialNumber)
            .then(() => {
                 return this.props.submitToInTray(invoiceId, supplierId, clientId, invoice);
            }).then(() => {
                notifyEvent(EventName.SELECTED_COMPANY, {
                    invoice
                })
            this.setState({
                ...this.state,
                loadingIntray: false,
                inTrayLinked: true,
                supplierFeedExists: !this.state.supplierFeedExists
            })
        }).catch(() => {
            this.setState({
                ...this.state,
                sendIntrayErrorMessage: 'Failed to link to business.'
            })
        });
    }

    closeSelectCompany = () => {
        this.setState({
            ...this.state,
            showSignIn: false,
            showSendIntray: false
        })
        const {invoiceId} = this.props.params;
        this.props.closeSelectCompany(invoiceId).catch(error => {
            console.log('close select company error:' + error + invoiceId)
        })
    }


    // unlink myob
    unlinkFromInTray = () => {
        const {notifyEvent} = this.props;
        const {invoice} = this.state;
        notifyEvent(EventName.UNLINK_FROM_INTRAY_BUTTON, {
            invoice
        });
        this.setState({
            ...this.state,
            loadingIntray: true
        })
        this.getSupplierFeed(this.state.invoice)
            .then(res => {
                const clientHash = res.client;
                const supplierHash = res.supplier;
                return this.props.removeSupplierFeed(supplierHash, clientHash);
            }).then(() => {
            this.setState({
                ...this.state,
                inTrayLinked: false,
                supplierFeedExists: !this.state.supplierFeedExists,
                loadingIntray: false
            });
        }).catch(() => {
            this.setState({
                ...this.state,
                sendIntrayErrorMessage: 'Unlink from in tray error.',
                loadingIntray: false
            });
        })
    }

    removeLinkFromMYOB = () => {
        const {notifyEvent} = this.props;
        const {invoice} = this.state;
        notifyEvent(EventName.UNLINKED_FROM_INTRAY, {
            invoice
        });

        this.setState({
            ...this.state,
            loadingIntray: false,
            sendIntrayErrorMessage: '',
            showSendIntray: false,
            showUnlink: true
        });
    }

    closeUnlinkFromMYOB = () => {
        this.setState({
            ...this.state,
            showUnlink: false
        });
    }

    print = () => {
        const publicUrl = process.env.REACT_APP_REDIRECT_URL ? process.env.REACT_APP_REDIRECT_URL : '';
        const downloadPdfUrl = publicUrl + this.state.invoice.print_pdf_url;
        const myWindow = window.open(downloadPdfUrl, 'Print Window ')
        window['closeSelectCompany'] = this.closeSelectCompany()
        if (myWindow) {
            myWindow.focus();
            myWindow.addEventListener('load', myWindow.print, true);
        }
    }
}

export default ViewInvoice;

